(ns minorodata.usage-account.events
  (:require
   [minorodata.usage-account.api]
   [re-frame.core :as re-frame]))

(defn init
  [{:keys [db]} [_ params]]
  (let [generation (inc (get-in db [:usage-account :generation] 0))
        params     (assoc params :generation generation)]
    {:db         (-> db
                     (assoc-in [:usage-account :generation] generation)
                     (assoc-in [:usage-account :query-cost-status] :loading)
                     (assoc-in [:usage-account :previous-totals-status] :loading)
                     (assoc-in [:usage-account :warehouse-runtime-status] :loading)
                     (assoc-in [:usage-account :heatmap-status] :loading)
                     (update :usage-account dissoc :query-cost :previous-totals :warehouse-runtime :load-profile))
     :dispatch-n [[:usage-account.api/fetch-query-cost params]
                  [:usage-account.api/fetch-previous-totals params]
                  [:usage-account.api/fetch-warehouse-runtime params]
                  [:usage-account.api/fetch-load-profile params]]}))

(re-frame/reg-event-fx
 :usage-account.events/init
 init)

(defn init-diagnosis
  [{:keys [db]} [_ params]]
  (let [generation             (inc (get-in db [:usage-account :diagnosis-generation] 0))
        shape-summary-seq      (inc (get-in db [:usage-account :shape-summary-seq] 0))
        shapes-seq             (inc (get-in db [:usage-account :shapes-seq] 0))
        query-type-series-seq  (inc (get-in db [:usage-account :query-type-series-seq] 0))
        params                 (assoc params :generation generation)]
    {:db         (-> db
                     (assoc-in [:usage-account :diagnosis-generation] generation)
                     (assoc-in [:usage-account :shape-summary-seq] shape-summary-seq)
                     (assoc-in [:usage-account :shapes-seq] shapes-seq)
                     (assoc-in [:usage-account :query-type-series-seq] query-type-series-seq)
                     (assoc-in [:usage-account :filter-options-status] :loading)
                     (assoc-in [:usage-account :shape-summary-status] :loading)
                     (assoc-in [:usage-account :shapes-status] :loading)
                     (assoc-in [:usage-account :query-type-series-status] :loading))
     :dispatch-n [[:usage-account.api/fetch-filter-options params]
                  [:usage-account.api/fetch-shape-summary (assoc params :seq shape-summary-seq)]
                  [:usage-account.api/fetch-shapes (assoc params :seq shapes-seq)]
                  [:usage-account.api/fetch-query-type-series (assoc params :seq query-type-series-seq)]]}))

(re-frame/reg-event-fx
 :usage-account.events/init-diagnosis
 init-diagnosis)

(defn refresh-diagnosis-query-type
  [{:keys [db]} [_ params]]
  (let [generation        (get-in db [:usage-account :diagnosis-generation] 0)
        shape-summary-seq (inc (get-in db [:usage-account :shape-summary-seq] 0))
        shapes-seq        (inc (get-in db [:usage-account :shapes-seq] 0))
        params            (assoc params :generation generation)]
    {:db         (-> db
                     (assoc-in [:usage-account :shape-summary-seq] shape-summary-seq)
                     (assoc-in [:usage-account :shapes-seq] shapes-seq)
                     (assoc-in [:usage-account :shape-summary-status] :loading)
                     (assoc-in [:usage-account :shapes-status] :loading))
     :dispatch-n [[:usage-account.api/fetch-shape-summary (assoc params :seq shape-summary-seq)]
                  [:usage-account.api/fetch-shapes (assoc params :seq shapes-seq)]]}))

(re-frame/reg-event-fx
 :usage-account.events/refresh-diagnosis-query-type
 refresh-diagnosis-query-type)

(defn refresh-diagnosis-dimension
  [{:keys [db]} [_ params]]
  (let [generation             (get-in db [:usage-account :diagnosis-generation] 0)
        shape-summary-seq      (inc (get-in db [:usage-account :shape-summary-seq] 0))
        shapes-seq             (inc (get-in db [:usage-account :shapes-seq] 0))
        query-type-series-seq  (inc (get-in db [:usage-account :query-type-series-seq] 0))
        params                 (assoc params :generation generation)]
    {:db         (-> db
                     (assoc-in [:usage-account :shape-summary-seq] shape-summary-seq)
                     (assoc-in [:usage-account :shapes-seq] shapes-seq)
                     (assoc-in [:usage-account :query-type-series-seq] query-type-series-seq)
                     (assoc-in [:usage-account :shape-summary-status] :loading)
                     (assoc-in [:usage-account :shapes-status] :loading)
                     (assoc-in [:usage-account :query-type-series-status] :loading))
     :dispatch-n [[:usage-account.api/fetch-shape-summary (assoc params :seq shape-summary-seq)]
                  [:usage-account.api/fetch-shapes (assoc params :seq shapes-seq)]
                  [:usage-account.api/fetch-query-type-series (assoc params :seq query-type-series-seq)]]}))

(re-frame/reg-event-fx
 :usage-account.events/refresh-diagnosis-dimension
 refresh-diagnosis-dimension)

(defn refresh-diagnosis-limit
  [{:keys [db]} [_ params]]
  (let [generation (get-in db [:usage-account :diagnosis-generation] 0)
        shapes-seq (inc (get-in db [:usage-account :shapes-seq] 0))
        params     (assoc params :generation generation :seq shapes-seq)]
    {:db       (-> db
                   (assoc-in [:usage-account :shapes-seq] shapes-seq)
                   (assoc-in [:usage-account :shapes-status] :loading))
     :dispatch [:usage-account.api/fetch-shapes params]}))

(re-frame/reg-event-fx
 :usage-account.events/refresh-diagnosis-limit
 refresh-diagnosis-limit)
